import { useRouter } from "expo-router";
import { useState } from "react";

import { authClient } from "../../auth-client";
import { Button } from "../../components/button";
import { Section } from "./section";

// Single button: sign out. Drops the BetterAuth session cookie + sends
// the user back to the root dispatcher.
export function SessionSection(): JSX.Element {
  const router = useRouter();
  const [busy, setBusy] = useState(false);

  async function handleSignOut(): Promise<void> {
    setBusy(true);
    try {
      await authClient.signOut();
      router.replace("/");
    } finally {
      setBusy(false);
    }
  }

  return (
    <Section title="Session">
      <Button
        variant="secondary"
        fullWidth
        onPress={handleSignOut}
        disabled={busy}
        busy={busy}
        label={busy ? "Signing out…" : "Sign out"}
        accessibilityLabel="Sign out of PassFirst"
        testID="settings-sign-out"
      />
    </Section>
  );
}
